export const formatPhoneNumber = (event) => {
    const { name, value } = event.target;
    const cleaned = value.replace(/\D/g, '');
    const truncated = cleaned.slice(0, 10);
    let formatted = truncated;
    if (truncated.length > 3) {
        formatted = `${truncated.slice(0, 3)}-${truncated.slice(3)}`;
    }
    if (truncated.length > 6) {
        formatted = `${truncated.slice(0, 3)}-${truncated.slice(3, 6)}-${truncated.slice(6)}`;
    }

    return {
        target: {
            name,
            value: formatted
        }
    };
};
